import { getColor } from "../../../theme";
export default (function (_a) {
    var boxShadow = _a.boxShadow, theme = _a.theme;
    if (!boxShadow)
        return "";
    var color = boxShadow.color ? getColor(boxShadow.color)({ theme: theme }) : "";
    var size = boxShadow.size ? boxShadow.size : "";
    if (!size)
        return "";
    return "box-shadow:".concat(size, " ").concat(color, ";");
});
